import { authAxios, publicAxios } from "../config";
import { ApiKey } from "../endpoints";

export const fetchInventoryReq = async () => {
  try {
    const res = await publicAxios.get(`${ApiKey.Inventory}`);

    const _data = res.data;
    return {
      error: false,
      data: _data,
      message: "",
      errorMsg: "",
    };
  } catch (err) {
    let error;

    if (err.response)
      error = err.response.data.message || "Response error";
    else if (err.request)
      error = "Request error";
    else
      error = "Something went wrong please try again later";

    throw {
      error: true,
      data: "",
      message: "",
      errorMsg: error,
    };
  }
};

export const fetchInventoryListReq = async () => {
  try {
    const res = await publicAxios.get(`${ApiKey.Inventory}`);

    const _data = res.data;

    return {
      error: false,
      data: _data,
      message: "",
      errorMsg: "",
    };
  } catch (err) {
    let error;

    if (err.response)
      error = err.response.data.message || "Response error";
    else if (err.request)
      error = "Request error";
    else
      error = "Something went wrong please try again later";

    throw {
      error: true,
      data: "",
      message: "",
      errorMsg: error,
    };
  }
};

export const addNewInventoryReq = async (data) => {
  try {
    const res = await publicAxios.post(
      `${ApiKey.Inventory}`,
      data
    );

    const msg = res.data.message;
    const _data = res.data;

    return {
      error: false,
      data: _data,
      message: msg,
      errorMsg: "",
    };
  } catch (err) {
    let error;

    if (err.response)
      error = err.response.data.message || "Response error";
    else if (err.request)
      error = "Request error";
    else
      error = "Something went wrong please try again later";

    throw {
      error: true,
      data: "",
      message: "",
      errorMsg: error,
    };
  }
};

export const updateInventoryReq = async (data) => {
  try {
    const res = await publicAxios.put(
      `${ApiKey.Inventory}`,
      data
    );

    const msg = res.data.message;
    const _data = res.data;

    return {
      error: false,
      data: _data,
      message: msg,
      errorMsg: "",
    };
  } catch (err) {
    let error;

    if (err.response)
      error = err.response.data.message || "Response error";
    else if (err.request)
      error = "Request error";
    else
      error = "Something went wrong please try again later";

    throw {
      error: true,
      data: "",
      message: "",
      errorMsg: error,
    };
  }
};

export const deleteInventoryReq = async (actionId) => {
  try {
    const res = await publicAxios.delete(
      `${ApiKey.Inventory}/${actionId}`
    );

    const msg = res.data?.message;
    const _data = res.data;

    return {
      error: false,
      data: _data,
      message: msg,
      errorMsg: "",
    };
  } catch (err) {
    let error;

    if (err.response)
      error = err.response.data.message || "Response error";
    else if (err.request)
      error = "Request error";
    else
      error = "Something went wrong please try again later";

    throw {
      error: true,
      data: "",
      message: "",
      errorMsg: error,
    };
  }
};


// =====================================================
// UPLOAD INVENTORY CSV
// =====================================================

// =====================================================
// UPLOAD INVENTORY CSV REQUEST
// =====================================================
export const uploadInventoryCsvReq = async (file) => {
  try {
    const formData = new FormData();

    formData.append("file", file);

    const res = await publicAxios.post(
      `${ApiKey.Inventory}/bulk-upload`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    const responseData = res.data;

    // =================================================
    // BACKEND VALIDATION FAILED
    // =================================================

    if (responseData?.success === false) {
      throw {
        error: true,
        data: responseData,
        message:
          responseData?.message ||
          "CSV validation failed.",
        errorMsg:
          responseData?.message ||
          "CSV validation failed.",
        errors:
          responseData?.errors || [],
      };
    }

    // =================================================
    // SUCCESS
    // =================================================

    return {
      error: false,
      data: responseData,
      message:
        responseData?.message ||
        "Inventory uploaded successfully.",
      errorMsg: "",
      errors: [],
    };

  } catch (err) {
    console.log(
      "UPLOAD CSV API ERROR:",
      err
    );

    // If this is our manually thrown validation error
    if (err?.error === true) {
      throw err;
    }

    // Axios error
    const responseData =
      err?.response?.data;

    const errorMessage =
      responseData?.message ||
      "CSV upload failed.";

    const validationErrors =
      responseData?.errors || [];

    throw {
      error: true,
      data: responseData || "",
      message: errorMessage,
      errorMsg: errorMessage,
      errors: validationErrors,
    };
  }
};

// =====================================================
// DOWNLOAD INVENTORY REPORT
// =====================================================
export const downloadInventoryReportReq = async () => {
  try {
    debugger;
    const res = await publicAxios.get(
      `${ApiKey.Inventory}/download-report`,
      {
        responseType: "blob",
      }
    );

    return res;

  } catch (err) {
    let error;

    if (err.response)
      error =
        err.response.data?.message ||
        "Download failed";
    else if (err.request)
      error = "Request error";
    else
      error = "Something went wrong please try again later";

    throw {
      error: true,
      data: "",
      message: "",
      errorMsg: error,
    };
  }
};